<template>
  <van-cell-group class="fieldScored mt1_5">
    <span ref="input" contenteditable></span>
    <van-cell :title="userName">
      <i
        slot="icon"
        :class="['iconfont', 'mr1', gender === '女' ? 'icon-woman danger-light' : 'icon-man primary']"
      />
      <span class="cell-value">{{ value }} 分</span>
    </van-cell>
    <div class="cell-btn-wrap flex fill-width h6">
      <div class="cell-btn-rescore center col-6" @click="openDialog">
        <i class="iconfont icon-xiugai mr1" style="font-size: 12px;"/>修改评分
      </div>
      <div class="cell-btn-divider"/>
      <div class="cell-btn-cancle center h6 col-6" @click="cancleScore">
        <i
          class="iconfont icon-cancel mr1"
          style="font-size: 12px; color: #ddd"
        />撤销评分
      </div>
    </div>
    <van-dialog
      v-model="showDialog"
      :get-container="getDialogContainer"
      :before-close="beforeClose"
      confirm-button-text="保存"
      show-cancel-button
    >
      <van-field label="发言人" :value="userName" readonly></van-field>
      <van-field
        v-model="score"
        ref="field"
        type="tel"
        label="分数"
        :error="unLegal"
        :error-message="errorMessage"
        placeholder="请输入分数（60~120分）"
        clearable
        @input="handleInput"
      />
    </van-dialog>
  </van-cell-group>
</template>

<script>
import Bus from '@/utils/eventBus'
import { handleToNumber } from '@/utils'

export default {
  name: 'FieldScored',
  props: {
    value: {
      type: [String, Number],
      required: true
    },
    id: {
      type: [String, Number],
      required: true
    },
    pk: {
      type: [String, Number],
      required: true
    },
    userName: {
      type: String,
      required: true
    },
    gender: {
      type: String
    }
  },
  data() {
    return {
      showDialog: false,
      score: this.value,
      // 第一次提交前输入不校验
      isFirstValidate: true
    }
  },
  computed: {
    unLegal() {
      const score = Number.parseInt(this.score) || 0
      return !this.isFirstValidate && (score < 60 || score > 120)
    },
    errorMessage() {
      return this.unLegal && this.score !== '' ? '分数只能在 60~120 之间' : ''
    }
  },
  methods: {
    openDialog() {
      this.score = this.value
      this.showDialog = true
      this.$refs['input'].focus()
      this.$nextTick(() => {
        this.$refs['field'].focus()
      })
    },
    cancleScore() {
      this.$dialog
        .confirm({
          title: '确定撤销评分？',
          message: '撤销后可以到未评分里再次评分'
        })
        .then(() => {
          this.$http
            .post(`deletescore?id=${this.pk}`)
            .then(() => {
              setTimeout(() => {
                this.$emit('update:saved', false)
                Bus.$emit('change-scored-count', -1)
              }, 200)
              this.$toast({
                type: 'success',
                message: '撤销成功',
                duration: 1000
              })
            })
            .catch(() => {
              this.$toast({
                type: 'fail',
                message: '撤销失败',
                duration: 1000
              })
            })
        })
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        this.isFirstValidate = false
        if (this.unLegal) {
          done(false)
          this.$refs['field'].focus()
        } else {
          this.$http
            .post(`editscore?targetuid=${this.id}&score=${this.score}`)
            .then(() => {
              this.$emit('input', this.score)
              this.$refs['field'].blur()
              done()
              window.scrollTo(0, 0)
              this.$toast({
                type: 'success',
                message: '修改成功',
                duration: 1000
              })
            })
            .catch(() => {
              this.$toast({
                type: 'fail',
                message: '修改失败',
                duration: 1500
              })
            })
        }
      } else {
        this.$refs['field'].focus()
        done()
        setTimeout(() => {
          this.$refs['field'].blur()
          window.scrollTo(0, 0)
        }, 200)
      }
    },
    handleInput(value) {
      this.score = handleToNumber({ value })
    },
    getDialogContainer() {
      return document.querySelector('#app')
    }
  }
}
</script>

<style lang="less" scoped>
.fieldScored {
  &::after {
    border: none;
  }
  /deep/.van-field__control::placeholder {
    color: @info;
  }
  .van-cell {
    align-items: center;
  }
  .cell-value {
    color: #333;
    font-size: 12px;
    font-weight: 700;
  }
  .cell-btn(@color) {
    color: @color;
    &:active {
      background: #e7e7e7;
    }
  }
  .cell-btn-wrap {
    height: 40px;
    line-height: 40px;
    .cell-btn-rescore {
      .cell-btn(#ffc107);
    }
    .cell-btn-divider {
      margin: 6px 0;
      border-right: 1px solid #f1f1f1;
    }
    .cell-btn-cancle {
      .cell-btn(#999);
    }
  }
}
</style>
